import {
  ExportFormatEnum,
  IExportOption,
} from '@g99-product-web-ui/shared-interface-lib';

export const EXPORT_OPTIONS: IExportOption[] = [
  { format: ExportFormatEnum.PDF, label: 'Export to PDF', icon: 'PDF' },
  { format: ExportFormatEnum.EXCEL, label: 'Export to Excel', icon: 'XLS' },
  { format: ExportFormatEnum.CSV, label: 'Export to CSV', icon: 'CSV' },
  { format: ExportFormatEnum.ZIP, label: 'Export to ZIP', icon: 'ZIP' },
  { format: ExportFormatEnum.JPG, label: 'Export to JPG', icon: 'JPG' },
];

export const FILE_EXTENSION = {
  [ExportFormatEnum.PDF]: 'pdf',
  [ExportFormatEnum.EXCEL]: 'xlsx',
  [ExportFormatEnum.CSV]: 'csv',
  [ExportFormatEnum.ZIP]: 'zip',
  [ExportFormatEnum.JPG]: 'jpg',
};
